import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    leaveList: {
        requesting: false,
        items: [],
        pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
	},
        error: null,
        success: false,
        filters: {},
    },
    leaveDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const leaveSlice = createSlice({
  name: 'leave',
  initialState,
  reducers: {
    getLeaveList: (state, action) => {
        state.leaveList.requesting = true;
        state.leaveList.error = null;
        state.leaveList.items = [];
        state.leaveList.success = false;
        state.leaveList.filters = action.payload;
    },
    getLeaveListSuccess: (state, action) => {
        const { data, current_page, per_page, total} = action.payload;   
        state.leaveList.requesting = false;
        state.leaveList.items = data;
        state.leaveList.success = true; 
        state.leaveList.pagination.current_page = current_page;
        state.leaveList.pagination.per_page = per_page;
        state.leaveList.pagination.total = total;
    },
    getLeaveListFail: (state, action) => {        
        state.leaveList.requesting = false;
        state.leaveList.error = action.payload;
    },
    getLeaveDetails: (state) => {
        state.leaveDetails.requesting = true;
        state.leaveDetails.error = null;
        state.leaveDetails.data = null;
        state.leaveDetails.success = false; 
    },
    getLeaveDetailsSuccess: (state, action) => {
        state.leaveDetails.requesting = false;
        state.leaveDetails.data = action.payload;
        state.leaveDetails.success = true; 
    },
    getLeaveDetailsFail: (state, action) => {        
        state.leaveDetails.requesting = false;
        state.leaveDetails.error = action.payload;
    },
    doLeaveCreate: (state) => {
        state.leaveDetails.requesting = true;
        state.leaveDetails.error = null;
        state.leaveDetails.data = null;
        state.leaveDetails.success = false; 
    },
    doLeaveUpdate: (state) => {
        state.leaveDetails.requesting = true;
        state.leaveDetails.error = null;
        state.leaveDetails.data = null;
        state.leaveDetails.success = false; 
    },
    doLeaveDelete: (state) => {
        state.leaveDetails.requesting = true;
        state.leaveDetails.error = null;
        state.leaveDetails.data = null;
        state.leaveDetails.success = false; 
    },
  },
})

export const { 
    getLeaveList, getLeaveListSuccess, getLeaveListFail,
    getLeaveDetails, getLeaveDetailsSuccess, getLeaveDetailsFail,
    doLeaveCreate, doLeaveUpdate, doLeaveDelete
} = leaveSlice.actions

export default leaveSlice.reducer